<template>
    <div class="step-evaluation-class">
        <v-alert type="info" text dense color="primary" class="mb-4">
            <div class="details-text">
                <strong>Note:</strong> The evaluation class is <strong>15 minutes</strong> long and helps us assess your current level.
            </div>
        </v-alert>
        <v-row>
            <v-col cols="12" md="6">
                <v-menu 
                    v-model="evaluationDateMenu" 
                    :close-on-content-click="false" 
                    :nudge-right="40" 
                    transition="scale-transition" 
                    offset-y 
                    min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field 
                            outlined 
                            :value="evaluationDate" 
                            label="Evaluation Date" 
                            placeholder="Evaluation date" 
                            prepend-inner-icon="mdi-calendar" 
                            readonly 
                            hide-details 
                            v-bind="attrs" 
                            v-on="on"
                        />
                    </template>
                    <v-date-picker 
                        :min="minEvaluationDate" 
                        :value="evaluationDate" 
                        @input="onEvaluationDateChange" 
                        color="primary"
                    />
                </v-menu>
            </v-col>
            <v-col cols="12" md="6">
                <time-input 
                    :value="evaluationTime" 
                    @input="$emit('update:evaluationTime', $event)"
                    :dense="mobile" 
                    :hide-icon="mobile" 
                    half-format 
                    outlined 
                    label="Evaluation Class Time (15 min)" 
                    placeholder="Evaluation Class Time" 
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import TimeInput from '@/components/custom/time-input';

export default {
    name: 'WizardStepEvaluation',
    components: {
        TimeInput
    },
    props: {
        evaluationDate: {
            type: String,
            default: ''
        },
        evaluationTime: {
            type: String,
            default: ''
        },
        minEvaluationDate: {
            type: String,
            required: true
        },
        mobile: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            evaluationDateMenu: false
        };
    },
    methods: {
        onEvaluationDateChange(date) {
            this.$emit('update:evaluationDate', date);
            this.evaluationDateMenu = false;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>

